import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from 'store/actions/tickets';
import { CompaniesResponse } from 'store/types/tickets';

const initialState: Array<CompaniesResponse> = [];

export const CompaniesReducer = createReducer<Array<CompaniesResponse>, ActionType<typeof actions>>(
  initialState,
).handleAction(actions.getCompanies.success, (state, { payload }) => ({
  ...state,
  ...payload,
}));
